module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/main-view@2x_c9f679228e4db34a46f76cf7222c82d9.png";